import React, { useEffect } from 'react';
import BranchInventoryTable from './BranchInventoryTable';
import BranchInventoryPaginator from './BranchInventoryPaginator';
import TabPageContainer from '~components/atoms/TabPageContainer';
import BranchInventorySummary from './BranchInventorySummary';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { useSelector } from 'react-redux';
import { RootState } from '~types/redux/store';
import combinedActions from '~redux/combinedActions';

const BranchInventory = () => {
    const dispatch = useAppDispatch();

    const branchCode = useAppSelector(
        (state) => state.gold.goldInventoryReport.branchInventory.filters.branchCode
    );
    const branchesList = useAppSelector(state => state.branch.allBranches);

    const { totalInventoryStock, totalInventoryUsed, totalInventoryBalance } = useSelector(
        (state: RootState) => state.gold.inventoryUsage
    );

    useEffect(() => {
        const branchId = branchesList.find(branch => branch.branchCode === branchCode)?.branchId;
        dispatch(combinedActions.goldGetInventoryUsageAttempt(branchId ? { branchId } : {}));
    }, [dispatch, branchCode, branchesList]);

    return (
        <TabPageContainer>
            <BranchInventorySummary
                total={totalInventoryStock}
                used={totalInventoryUsed}
                balance={totalInventoryBalance}
            />
            <BranchInventoryTable />

            <BranchInventoryPaginator />
        </TabPageContainer>
    );
};

export default BranchInventory;
